import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--brand-accent)]/50 focus:ring-offset-2 focus:ring-offset-[var(--bg-main)]",
  {
    variants: {
      variant: {
        default:
          "border-[rgba(47,128,237,0.3)] bg-[rgba(47,128,237,0.15)] text-[var(--brand-accent)]",
        secondary:
          "border-[rgba(148,163,184,0.3)] bg-[rgba(148,163,184,0.15)] text-[var(--text-secondary)]",
        destructive:
          "border-[rgba(235,87,87,0.3)] bg-[rgba(235,87,87,0.15)] text-[var(--status-critical)]",
        outline: "text-[var(--text-secondary)] border-[var(--border-default)] bg-transparent",
        success:
          "border-[rgba(39,174,96,0.3)] bg-[rgba(39,174,96,0.15)] text-[var(--status-success)]",
        warning:
          "border-[rgba(242,201,76,0.3)] bg-[rgba(242,201,76,0.15)] text-[var(--status-warning)]",
        active:
          "border-[rgba(45,156,219,0.3)] bg-[rgba(45,156,219,0.15)] text-[var(--status-active)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
